"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";

export default function NotFound() {
  const pathname = usePathname();
  const isEn = pathname?.startsWith("/en/") || pathname === "/en";

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4 text-center">
      <Link href={isEn ? "/en" : "/"} aria-label="Velyq" className="mb-6">
        <Logo size="lg" />
      </Link>
      <p className="text-sm font-semibold uppercase tracking-widest text-primary">404</p>
      <h1 className="mt-2 text-3xl font-bold sm:text-4xl">
        {isEn ? "Page not found" : "Page introuvable"}
      </h1>
      <p className="mt-3 max-w-md text-muted-foreground">
        {isEn
          ? "This page doesn't exist or has been moved. Let's head back home to continue your prep."
          : "Cette page n'existe pas ou a été déplacée. Retournons à l'accueil pour continuer ta préparation."}
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Button asChild size="lg">
          <Link href={isEn ? "/en" : "/"}>
            {isEn ? "Back to home" : "Retour à l'accueil"}
          </Link>
        </Button>
        <Button asChild size="lg" variant="outline">
          <Link href={isEn ? "/en/dashboard" : "/dashboard"}>
            {isEn ? "My dashboard" : "Mon dashboard"}
          </Link>
        </Button>
      </div>
    </div>
  );
}
